<template>
  <div class="holiday">
    <div class="time">{{ roleId == 3 ? '本校节假日安排' : '系统全局节假日安排' }}
      <a-popover arrow-point-at-center placement="bottomLeft">
        <template slot="content">
          <ol style="list-style-type: disc;">
            <template v-if="roleId == 3">
              <li>1.本校设置将影响学校开班的课时安排；</li>
              <li>2.放假日期不会安排课节，调课至日期即使是周六周日也会根据放假的日期是星期几调课到目标日期安排星期几的课节；</li>
              <li>3.学校设置各自独立互不影响，学校设置在教育局设置基础之上添加放假调课规则；</li>
            </template>
            <template v-else>
              <li>1.系统全局设置将影响所有教育局站点、所有学校开班的课时安排；</li>
              <li>2.放假日期不会安排课节，调课至日期即使是周六周日也会根据放假的日期是星期几调课到目标日期安排星期几的课节；</li>
              <li>3.同时教育局和学校也会有各自的独立设置；</li>
            </template>
            <li>4.最终可排课日期为：学校的设置+教育局设置+全局设置，三者叠加；</li>
            <li>5.节假日设置优先级：学校的设置>教育局设置>全局设置。</li>
          </ol>
        </template>
        <a-icon type="question-circle" />
      </a-popover>
      <a-button type="link" @click="changeYear(-1)">上年度{{ currentYear - 1 }}</a-button>
      <a-button type="link" @click="changeYear(0)">本年度{{ currentYear }}</a-button>
      <a-button type="link" @click="changeYear(1)">下年度{{ currentYear + 1 }}</a-button>
    </div>
    <div class="calendar">
      <div v-for="month in 12" :key="month" class="month">
        <Calendar :year="year" :month="month - 1" :selectedRange="selectedRange" :hoveredRange="hoveredRange"
          :pause="pause" :formattedSelectedRange="formattedSelectedRange" :dateData="processedDateData"
          @select-day="handleSelectDay" @hover-day="handleHoverDay" @context-menu="handleContextMenu"
          @click-menu="handleClickMenu" @cancel-selection="cancelSelection" @add-cal="addCal" />
      </div>
      <div v-if="contextMenu.visible" class="context-menu" :style="contextMenu.style" ref="contextMenu">
        <a @click="handleContextMenuOption(1)">
          <p>设置放假</p>
        </a>
        <a @click="handleContextMenuOption(2)">
          <p>删除设置</p>
        </a>
        <a @click="handleContextMenuOption(3)">
          <p>取消选择</p>
        </a>
      </div>
    </div>
    <!-- 右侧抽屉 -->
    <a-drawer :visible="showDrawer" @close="onClose" width="40%">
      <div class="title">{{ drawerType == 1 ? '设置放假' : '删除设置' }}</div>
      <div class="time-box">
        <div class="time-list">
          <div class="line">
            <div class="header f1">放假日期</div>
            <div class="header f1">放假设置</div>
          </div>
          <div class="empty" v-if="!rangeList.length">
            <a-empty description="暂无放假设置" />
          </div>
          <div class="max-height">
            <div class="line" v-for="(item, index) in rangeList" :key="index">
              <div class="item f1">
                <span style="position: relative;">{{ item.dateItem }}
                  <a-popover arrow-point-at-center placement="bottom" v-if="item.comment" style="z-index: 99;">
                    <template slot="content">
                      备注：{{ item.comment }}
                    </template>
                    <a-icon class="icon-circle" type="question-circle" />
                  </a-popover>
                </span>
              </div>
              <div class="f1" style="background-color: #babaff;" v-if="item.replaceDate">
                调课至{{ item.replaceDate }}
                <div class="icon" v-if="drawerType == 1">
                  <a style="color: #1B1D26;" @click="removeDate(index)"><a-icon type="close" :width="16" /></a>
                </div>
              </div>
              <div class="f1" v-else>
                放假
                <div class="icon" v-if="drawerType == 1">
                  <a-date-picker @change="onChange($event, index)" :showToday="false" :defaultValue="item.momentDate"
                    :key="item.dateItem">
                    <a style="color: #abacad;"><a-icon type="calendar" :width="16" /></a>
                  </a-date-picker>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="remark" v-if="drawerType == 1">
        <h3>放假备注</h3>
        <a-input style="width: 100%;" placeholder="请输入放假备注" v-model="remarkText"></a-input>
      </div>
      <div class="btns" v-show="showDrawer">
        <a-button @click="onClose" style="margin-right: 12px;">取消</a-button>
        <a-button type="primary" @click="onSubmit" v-if="drawerType == 1">提交</a-button>
        <a-popconfirm title="确定删除吗？" placement="topRight" v-else @confirm="handleDelete" :disabled="!rangeList.length">
          <a-icon slot="icon" type="question-circle-o" style="color: red" />
          <a-button type="primary" :disabled="!rangeList.length">删除</a-button>
        </a-popconfirm>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import education from '../../api/education'
import Calendar from './components/Calendar.vue'
import Vue from 'vue'
import moment from 'moment'
export default {
  components: {
    Calendar
  },
  data() {
    return {
      year: new Date().getFullYear(),
      currentYear: new Date().getFullYear(),
      selectedRange: { start: null, end: null }, // 选中的日期范围
      hoveredRange: { start: null, end: null }, // hover 的日期范围
      contextMenu: {
        visible: false,
        style: {},
        day: null
      },
      showDrawer: false,
      pause: false,
      clickCal: 0,
      clickCount: 0,
      selectIds: [], // 选中日期的id，用于删除
      rangeList: [],
      rangeListCopy: [],
      remarkText: '',
      drawerType: 0, // 1: 设置放假，2: 删除设置
      dateData: [], // 存储接口返回的每个日期的数据
      roleId: Vue.ls.get('roleId'),
      roleType: Vue.ls.get('roleId') == 3 ? 8 : Vue.ls.get('roleId') == 6 ? 2 : null, // 管理员2 教育局4 学校8
    };
  },
  created() {
    this.getDateData()
  },
  computed: {
    formattedSelectedRange() {
      if (!this.selectedRange.start || !this.selectedRange.end) return []

      const startDate = new Date(
        this.selectedRange.start.year,
        this.selectedRange.start.month,
        this.selectedRange.start.day
      );
      const endDate = new Date(
        this.selectedRange.end.year,
        this.selectedRange.end.month,
        this.selectedRange.end.day
      );

      // 生成日期范围内的所有日期
      const dates = [];
      let currentDate = startDate;
      while (currentDate <= endDate) {
        dates.push({
          dateItem: currentDate.toLocaleDateString('en-CA'), // 格式化为 YYYY/MM/DD
          // dateType: this.roleType,
        });
        currentDate.setDate(currentDate.getDate() + 1); // 增加一天
      }
      return dates;
    },
    processedDateData() {
      // 将 dateData 按日期分组
      return this.dateData.reduce((acc, item) => {
        const date = new Date(item.dateItem).toLocaleDateString('en-CA'); // 格式化为 YYYY/MM/DD
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(item);
        return acc;
      }, {});
    }
  },
  mounted() {
    this.addEvent()
  },
  beforeDestroy() {
    this.removeEvent()
  },
  methods: {
    addEvent() {
      document.addEventListener('click', this.handleMouse);
      document.addEventListener('contextmenu', this.handleMouse);
    },
    removeEvent() {
      document.removeEventListener('click', this.handleMouse);
      document.removeEventListener('contextmenu', this.handleMouse);
    },
    handleMouse(event) {
      if (this.clickCal !== this.clickCount) {
        this.clickCount = this.clickCal
      } else {
        // event.preventDefault()
        this.cancelSelection()
      }
    },
    getDateData() {
      education.getHolidayArrange({ year: this.year }).then((res) => {
        this.dateData = res.data
        this.dateData.forEach(item => {
          let arr = item.calendarSettingDTOList
          if (arr.length > 1 && arr[arr.length - 1].dateSetting == -1) {
            arr.forEach(ele => {
              if (ele.replaceDate && ele.dateType !== this.roleType) {
                let temp = this.dateData.find(item => item.dateItem == ele.replaceDate).calendarSettingDTOList
                if (!temp.some(item => item.dateType == this.roleType)) {
                  temp.push({
                    dateSetting: 0,
                    dateItem: ele.replaceDate,
                    dateType: this.roleType,
                    comment: ele.comment,
                  })
                }
              }
            })
          }
        })
      }).catch(err => {
        console.log(err)
      })
    },
    changeYear(num) {
      if (!num) {
        this.year = new Date().getFullYear()
      } else {
        this.year = this.currentYear + num
      }
      this.getDateData()
    },
    cancelSelection() {
      // 取消日期范围选择
      this.selectedRange = { start: null, end: null };
      this.hoveredRange = { start: null, end: null };
      this.selectedRangeList = [];
      this.contextMenu.visible = false;
      this.clickCal = 0
      this.clickCount = 0
      this.pause = false
    },
    addCal() {
      // 保证日历的暂停状态正常
      this.clickCal += 2
    },
    handleSelectDay({ day, month, year }) {
      const date = { day, month, year };
      this.clickCal++
      // 处理点击日期是否在选择区间内，在就暂停可弹出弹框，不在则清除
      this.$nextTick(() => {
        if (this.selectedRange.end) {
          const startDate = new Date(
            this.selectedRange.start.year,
            this.selectedRange.start.month,
            this.selectedRange.start.day
          );
          const endDate = new Date(
            this.selectedRange.end.year,
            this.selectedRange.end.month,
            this.selectedRange.end.day
          )
          const currentDate = new Date(date.year, date.month, date.day);
          // clickCal双数表示完成选中，则要在日历组件中暂停进行判断
          if (currentDate >= startDate && currentDate <= endDate && this.clickCal % 2 == 0) {
            this.pause = true
            return
          }
        }
      })
      if (!this.selectedRange.start || this.selectedRange.end) {
        // 如果未选择起始日期或已经选择了结束日期，则重置
        this.selectedRange = { start: date, end: null };
      } else {
        // 选择结束日期
        const startDate = new Date(
          this.selectedRange.start.year,
          this.selectedRange.start.month,
          this.selectedRange.start.day
        );
        const endDate = new Date(year, month, day);
        if (endDate < startDate) {
          // 如果结束日期早于起始日期，则交换
          this.selectedRange = { start: date, end: this.selectedRange.start };
        } else {
          this.selectedRange.end = date;
        }
      }
      // 处理选中的时间范围数据
      this.processSelectedRangeData();
    },
    processSelectedRangeData() {
      const { start, end } = this.selectedRange;
      if (!start || !end) return;

      const startDate = new Date(start.year, start.month, start.day);
      const endDate = new Date(end.year, end.month, end.day);

      // 清空之前的选中数据
      this.rangeList = []
      this.selectIds = []
      // 遍历选中的日期范围
      let currentDate = startDate;
      while (currentDate <= endDate) {
        const dateKey = currentDate.toLocaleDateString('en-CA'); // 格式化为 YYYY/MM/DD
        const dateItems = this.processedDateData[dateKey] && this.processedDateData[dateKey][0] || { dateType: this.roleType };
        let setting = dateItems.calendarSettingDTOList && dateItems.calendarSettingDTOList[dateItems.calendarSettingDTOList.length - 1] || null
        if (setting && setting.dateType == this.roleType) {
          if (setting.id) {
            this.selectIds.push(setting.id)
          }
          let data = {
            dateItem: dateKey,
            momentDate: moment(dateKey, 'YYYY-MM-DD'),
            dateType: this.roleType,
            id: setting.dateType === this.roleType ? setting.id : null,
            comment: setting.dateType === this.roleType ? setting.comment : '',
            replaceDate: setting.dateType === this.roleType ? setting.replaceDate : null,
            replaceId: setting.dateType === this.roleType ? setting.replaceId : null
          };

          // 如果 dateSetting 为 1，则设置 replaceId 和 replaceDate
          if (setting.dateSetting === 1) {
            data.id = setting.parentId;
            data.replaceId = setting.id;
            data.replaceDate = setting.dateItem;
            data.dateItem = setting.parentDateItem;
          }
          this.rangeList.push(data);
        } else {
          let data = {
            dateItem: dateKey,
            momentDate: moment(dateKey, 'YYYY-MM-DD'),
            dateType: this.roleType,
            comment: '',
            id: null,
            replaceDate: null,
            replaceId: null
          }
          this.rangeList.push(data);
        }
        currentDate.setDate(currentDate.getDate() + 1); // 增加一天
      }

      // 对 rangeList 中的 dateItem 去重
      this.rangeList = this.rangeList.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.dateItem === item.dateItem)
      ).sort((a, b) => new Date(a.dateItem) - new Date(b.dateItem));
    },
    handleHoverDay({ day, month, year }) {
      if (this.selectedRange.start && !this.selectedRange.end) {
        // 如果已经选择了起始日期但未选择结束日期，则显示 hover 效果
        const startDate = new Date(
          this.selectedRange.start.year,
          this.selectedRange.start.month,
          this.selectedRange.start.day
        );
        const endDate = new Date(year, month, day);
        if (endDate < startDate) {
          this.hoveredRange = { start: { day, month, year }, end: this.selectedRange.start };
        } else {
          this.hoveredRange = { start: this.selectedRange.start, end: { day, month, year } };
        }
      } else {
        this.hoveredRange = { start: null, end: null };
      }
    },
    handleClickMenu({ day, event }) {
      this.contextMenu.visible = true;
      this.contextMenu.style = {
        left: `${event.clientX}px`,
        top: `${event.clientY}px`
      };
      this.contextMenu.day = day;
    },
    handleContextMenu({ day, event }) {
      this.handleClickMenu({ day, event })
      document.addEventListener('click', this.handleClickOutside);
    },
    handleContextMenuOption(type) {
      this.removeEvent()
      if (type == 3) {
        this.cancelSelection()
        this.clickCal += 2
        this.addEvent()
        return
      }
      const { start, end } = this.selectedRange;
      const startDate = dayjs(new Date(start.year, start.month, start.day)).format('YYYY-MM-DD');
      const endDate = dayjs(new Date(end.year, end.month, end.day)).format('YYYY-MM-DD');
      // 发请求获取选中日期数据
      let params = {
        startDate: startDate,
        endDate: endDate
      }
      education.getHolidayArrangeDetail(params).then(res => {
        this.rangeListCopy = JSON.parse(JSON.stringify(this.rangeList))
        if (type == 1) {
        } else {
          this.rangeList = res.data.map(item => {
            return {
              comment: item.comment,
              dateType: item.dateType,
              momentDate: moment(item.dateType, 'YYYY-MM-DD'),
              id: item.dateSetting === -1 ? item.id : item.parentId,
              replaceId: item.dateSetting === -1 ? item.replaceId : item.id,
              dateItem: item.dateSetting === -1 ? item.dateItem : item.parentDateItem,
              replaceDate: item.dateSetting === -1 ? item.replaceDate : item.dateItem,
            }
          })
          // 对 rangeList 中的 dateItem 去重
          this.rangeList = this.rangeList.filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.dateItem === item.dateItem)
          ).sort((a, b) => new Date(a.dateItem) - new Date(b.dateItem));
        }
        this.showDrawer = true
        this.drawerType = type
        this.contextMenu.visible = false;
        this.closeContextMenu();
      })
    },
    closeContextMenu() {
      this.contextMenu.visible = false;
      // 移除全局点击事件监听
      document.removeEventListener('click', this.handleClickOutside);
    },
    handleClickOutside(event) {
      const contextMenu = this.$refs.contextMenu;
      if (contextMenu && !contextMenu.contains(event.target)) {
        this.closeContextMenu();
      }
    },
    onClose() {
      this.showDrawer = false
      this.remarkText = ''
      let _this = this
      setTimeout(function () {
        _this.rangeList = JSON.parse(JSON.stringify(_this.rangeListCopy))
      }, 200) // 抽屉关闭动画的时间
      this.clickCal += 2
      this.addEvent()
    },
    onChange(event, index) {
      let date = dayjs(event._d).format('YYYY-MM-DD')
      if (this.rangeList.some(item => item.dateItem == date)) return this.$message.warning(date + '不能设置为放假日期')
      if (this.rangeList.some(item => item.replaceDate == date)) return this.$message.warning(date + '已经安排调课')
      this.rangeList[index].replaceDate = date
      this.$forceUpdate()
    },
    removeDate(index) {
      delete this.rangeList[index].replaceClassWeekday
      delete this.rangeList[index].replaceDate
      this.$forceUpdate()
    },
    onSubmit() {
      this.rangeList.forEach(item => {
        item.classWeekday = dayjs(item.dateItem).day() == 0 ? 7 : dayjs(item.dateItem).day()
        item.comment = this.remarkText
        for (let k in item) {
          if (item[k] == null) delete item[k]
        }
      })
      education.updateHolidayArrange(this.rangeList).then(res => {
        this.$message.success('提交成功')
        this.selectedRange = { start: null, end: null }
        this.getDateData()
        this.showDrawer = false
        this.remarkText = ''
        // 恢复日历可选状态
        this.pause = false
      })
    },
    handleDelete() {
      education.deleteHolidayArrange(this.selectIds).then(res => {
        this.$message.success('删除成功')
        this.selectedRange = { start: null, end: null }
        this.getDateData()
        this.showDrawer = false
        this.pause = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.holiday {
  margin: 20px;
  padding: 20px;
  background-color: #fff;
}

.time {
  font-size: 16px;
  font-weight: bold;
  color: #000;
}

.calendar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.context-menu {
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  padding: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  z-index: 9999;
}

.context-menu div {
  padding: 5px;
  cursor: pointer;
}

.context-menu div:hover {
  background-color: #f0f0f0;
}

::v-deep .ant-drawer-body {
  padding: 0;
  color: #1B1D26;
}

::v-deep .ant-drawer-close {
  transform: translateY(10px);
}

.title {
  padding: 27px 24px;
  background-color: #f1fafc;
  font-size: 16px;
  font-weight: bold;
}

.time-box {
  padding: 24px;

  .time-list {
    .f1 {
      position: relative;
      flex: 1;
      text-align: center;
      padding: 16px 0;

      .icon {
        position: absolute;
        top: 16px;
        right: 27px;
      }
    }

    .line {
      width: 100%;
      display: flex;
      border-bottom: 1px solid #e1d2d5;

      .header {
        background-color: #fafafa;
      }

      .item {
        background-color: #ffbaba;
        border-right: 1px solid #e1d2d5;
      }
    }

  }
}

.icon-circle {
  position: absolute;
  top: 2px;
  right: -22px;
}

.max-height {
  max-height: calc(100vh - 360px);
  overflow: auto;
}

.remark {
  padding: 0 24px;

  h3 {
    font-weight: bold;
    color: #1B1D26;
    margin-bottom: 16px;
  }
}

.btns {
  padding: 0 24px 24px;
  position: fixed;
  bottom: 0;
  right: 0;
  text-align: right;
}

.context-menu {
  border-radius: 6px;
  box-shadow: 3px 0px 8px rgba(0, 21, 41, 0.08);
  padding: 8px 16px;
}

.empty {
  padding: 40px 0;
  border-bottom: 1px solid #e1d2d5;
}
</style>